import { render, staticRenderFns } from "./UpdateRequired.vue?vue&type=template&id=73199c72&"
import script from "./UpdateRequired.vue?vue&type=script&lang=js&"
export * from "./UpdateRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports